<template>
  <v-card>
    <v-card-title>
      <h3>You haven't matched with lenders!</h3>
    </v-card-title>

    <v-card-text>
      <h4>
        To begin, choose the type of financing you are looking for:
      </h4>

      <DealTypeGrid
        small-cards
        @continue="goToQuestionnaire"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import DealTypeGrid from '@/modules/shared/components/DealTypeGrid'

export default {
  name: 'NoDeals',
  components: {
    DealTypeGrid,
  },

  methods: {
    async goToQuestionnaire (selected) {
      await this.$router.push({
        name: 'ChoosePractice',
        query: { dealType: selected },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  margin-top: 40px;

  .v-card__title {
    background: $primaryRed;
    color: white;
    justify-content: center;
  }

  .v-card__text {
    padding: 40px 30px;
  }

  h4 {
    margin-bottom: 30px;
    text-align: center;
  }
}

.body-header {
  font-family: "Avenir Medium";
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0;
  color: #3a3a3a;
  margin-bottom: 24px;
}

.deal-type-btn {
  width: 300px;
  height: 50px !important;
  background: #fff !important;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  margin-bottom: 25px;
  font-family: "Sansation Regular", Serif;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0;
  color: #3a3a3a;
  text-transform: none;
}
</style>
